/* tslint:disable */
/* eslint-disable */
/* @relayHash f7a7be0016817caf872c3fcb96643a2b */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MODERATOR" | "STAFF" | "UNANSWERED" | "%future added value";
export type CommentEnteredSubscriptionVariables = {
    storyID: string;
    ancestorID?: string | null;
};
export type CommentEnteredSubscriptionResponse = {
    readonly commentEntered: {
        readonly comment: {
            readonly id: string;
            readonly createdAt: string;
            readonly parent: {
                readonly id: string;
            } | null;
            readonly tags: ReadonlyArray<{
                readonly code: TAG;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_comment">;
        };
    };
};
export type CommentEnteredSubscription = {
    readonly response: CommentEnteredSubscriptionResponse;
    readonly variables: CommentEnteredSubscriptionVariables;
};



/*
subscription CommentEnteredSubscription(
  $storyID: ID!
  $ancestorID: ID
) {
  commentEntered(storyID: $storyID, ancestorID: $ancestorID) {
    comment {
      id
      createdAt
      parent {
        id
      }
      tags {
        code
      }
      ...AllCommentsTabContainer_comment
    }
  }
}

fragment AllCommentsTabContainer_comment on Comment {
  id
  ...CommentContainer_comment
  ...ReplyListContainer1_comment
  ...IgnoredTombstoneOrHideContainer_comment
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  ...ReplyCommentFormContainer_comment
  ...EditCommentFormContainer_comment
  ...ReactionButtonContainer_comment
  ...ReportFlowContainer_comment
  ...ReportButton_comment
  ...CaretContainer_comment
  ...RejectedTombstoneContainer_comment
  ...UserTagsContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UsernameContainer_comment
  ...MediaSectionContainer_comment
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment ReplyListContainer1_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer2_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...ReplyListContainer3_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_comment on Comment {
  id
  status
  replies(first: 10, orderBy: CREATED_AT_ASC) {
    edges {
      node {
        id
        replyCount
        ...CommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        ...LocalReplyListContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ancestorID"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "ancestorID",
            "variableName": "ancestorID"
        } as any),
        ({
            "kind": "Variable",
            "name": "storyID",
            "variableName": "storyID"
        } as any)
    ], v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v5 = [
        (v3 /*: any*/)
    ], v6 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v7 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v8 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            (v4 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v5 /*: any*/),
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v17 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v18 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v18 /*: any*/),
                            (v19 /*: any*/)
                        ],
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v18 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v22 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 10
        } as any),
        ({
            "kind": "Literal",
            "name": "orderBy",
            "value": "CREATED_AT_ASC"
        } as any)
    ], v23 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "localReplies",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            (v9 /*: any*/),
            (v23 /*: any*/),
            (v10 /*: any*/),
            (v4 /*: any*/),
            (v11 /*: any*/),
            (v12 /*: any*/),
            (v6 /*: any*/),
            (v25 /*: any*/),
            (v26 /*: any*/),
            (v13 /*: any*/),
            (v14 /*: any*/),
            (v15 /*: any*/),
            (v16 /*: any*/),
            (v21 /*: any*/)
        ],
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v29 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v3 /*: any*/),
                    (v24 /*: any*/),
                    (v28 /*: any*/),
                    (v9 /*: any*/),
                    (v23 /*: any*/),
                    (v10 /*: any*/),
                    (v4 /*: any*/),
                    (v11 /*: any*/),
                    (v12 /*: any*/),
                    (v6 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v21 /*: any*/),
                    (v27 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v32 = ({
        "alias": null,
        "args": (v22 /*: any*/),
        "filters": [
            "orderBy"
        ],
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v33 = ({
        "kind": "ClientExtension",
        "selections": [
            (v25 /*: any*/),
            (v26 /*: any*/),
            (v28 /*: any*/)
        ]
    } as any), v34 = ({
        "alias": null,
        "args": (v22 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v31 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            (v24 /*: any*/),
                            (v28 /*: any*/),
                            (v9 /*: any*/),
                            (v23 /*: any*/),
                            (v10 /*: any*/),
                            (v4 /*: any*/),
                            (v11 /*: any*/),
                            (v12 /*: any*/),
                            (v6 /*: any*/),
                            (v25 /*: any*/),
                            (v26 /*: any*/),
                            (v13 /*: any*/),
                            (v14 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v21 /*: any*/),
                            (v27 /*: any*/),
                            (v17 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v29 /*: any*/)
                ],
                "storageKey": null
            },
            (v30 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v29 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v3 /*: any*/),
                    (v28 /*: any*/),
                    (v9 /*: any*/),
                    (v23 /*: any*/),
                    (v10 /*: any*/),
                    (v4 /*: any*/),
                    (v11 /*: any*/),
                    (v12 /*: any*/),
                    (v6 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v21 /*: any*/),
                    (v34 /*: any*/),
                    (v32 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "CommentEnteredSubscription",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "CommentEnteredPayload",
                    "kind": "LinkedField",
                    "name": "commentEntered",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "comment",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": (v5 /*: any*/),
                                    "storageKey": null
                                },
                                (v6 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AllCommentsTabContainer_comment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Subscription",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "CommentEnteredSubscription",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "CommentEnteredPayload",
                    "kind": "LinkedField",
                    "name": "commentEntered",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "comment",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v8 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v6 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v21 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v22 /*: any*/),
                                    "concreteType": "CommentsConnection",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v21 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v22 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": (v22 /*: any*/),
                                                                                    "concreteType": "CommentsConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "replies",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "CommentEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Comment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v3 /*: any*/),
                                                                                                        (v24 /*: any*/),
                                                                                                        (v9 /*: any*/),
                                                                                                        (v23 /*: any*/),
                                                                                                        (v10 /*: any*/),
                                                                                                        (v4 /*: any*/),
                                                                                                        (v11 /*: any*/),
                                                                                                        (v12 /*: any*/),
                                                                                                        (v6 /*: any*/),
                                                                                                        (v13 /*: any*/),
                                                                                                        (v14 /*: any*/),
                                                                                                        (v15 /*: any*/),
                                                                                                        (v16 /*: any*/),
                                                                                                        (v21 /*: any*/),
                                                                                                        (v17 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v25 /*: any*/),
                                                                                                                (v26 /*: any*/),
                                                                                                                (v27 /*: any*/),
                                                                                                                (v28 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v29 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v30 /*: any*/),
                                                                                        {
                                                                                            "kind": "ClientExtension",
                                                                                            "selections": [
                                                                                                (v31 /*: any*/)
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                                },
                                                                                (v32 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v33 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v29 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v30 /*: any*/),
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        (v35 /*: any*/)
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                        },
                                                        (v32 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v33 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v29 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v30 /*: any*/),
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "viewNewEdges",
                                                    "plural": true,
                                                    "selections": [
                                                        (v29 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v23 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v25 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v15 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v21 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": (v22 /*: any*/),
                                                                    "concreteType": "CommentsConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "replies",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v35 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CommentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v3 /*: any*/),
                                                                                        (v28 /*: any*/),
                                                                                        (v9 /*: any*/),
                                                                                        (v23 /*: any*/),
                                                                                        (v10 /*: any*/),
                                                                                        (v4 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v12 /*: any*/),
                                                                                        (v6 /*: any*/),
                                                                                        (v25 /*: any*/),
                                                                                        (v26 /*: any*/),
                                                                                        (v13 /*: any*/),
                                                                                        (v14 /*: any*/),
                                                                                        (v15 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        (v21 /*: any*/),
                                                                                        (v34 /*: any*/),
                                                                                        (v32 /*: any*/),
                                                                                        (v17 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v29 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v30 /*: any*/)
                                                                    ],
                                                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                                                },
                                                                (v32 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\")"
                                },
                                (v32 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        (v25 /*: any*/),
                                        (v26 /*: any*/)
                                    ]
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "f7a7be0016817caf872c3fcb96643a2b",
            "metadata": {},
            "name": "CommentEnteredSubscription",
            "operationKind": "subscription",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'f33f151970a2dcf15fdc224bdb9b0a76';
export default node;
